import { type HeadItemType, Table } from 'components/Table'
import type { LeadTimesUploadError } from 'services/leadTimes'

import * as S from './styles'

const headDataLeadTimes: HeadItemType[] = [
  { columnName: 'material', label: 'Material' },
  { columnName: 'description', label: 'Descrição' },
  { columnName: 'technology', label: 'Tecnologia' },
  { columnName: 'error', label: 'Erro' },
]

interface UploadSpreadsheetTableErrorProps {
  data: LeadTimesUploadError[]
}

export const UploadSpreadsheetTableError: React.FC<UploadSpreadsheetTableErrorProps> = ({
  data,
}) => {
  if (!data || data.length === 0) {
    return null
  }

  const renderSummary = () => {
    const amount = data?.length ?? 0
    return amount > 1 ? `${amount} erros encontrados` : `${amount} erro encontrado`
  }

  const renderBody = () => {
    return data.map((item) => {
      const key = `${item.material}-${item.description}-${item.error}`

      return {
        content: [
          <span key={`Material-${key}`}>{item.material ?? '-'}</span>,
          <span key={`Description-${key}`}>{item.description ?? '-'}</span>,
          <span key={`Technology-${key}`}>{item.technology ?? '-'}</span>,
          <S.DataWrapError key={`Erro-${key}`}>
            <span>{item.error}</span>
          </S.DataWrapError>,
        ],
        id: `id-${key}`,
      }
    })
  }

  const headData = headDataLeadTimes

  return (
    <S.Container>
      <S.Summary>{renderSummary()}</S.Summary>
      <Table bodyData={renderBody()} headData={headData} rowHeight={40} />
    </S.Container>
  )
}
